// YERİ: src/app/domains/site/sections/blog-preview.section.ts
// Blog Önizleme — kart ızgarası (görsel + başlık + özet + tarih + bağlantı).
// Config'ten okur (şema-tabanlı form). Tema CSS vars ile renklenir.

import { Component, OnInit, computed, effect, inject, input, signal, untracked } from '@angular/core';
import { SiteConfig, cfg } from './section.model';
import { SiteChromeText } from '../core/site-chrome-text';
import { TenantWebService } from '../core/tenant-web.service';

interface BlogKart {
  image?: string;
  title: string;
  excerpt?: string;
  date?: string;
  url?: string;
}

@Component({
  selector: 'sec-blog-preview',
  standalone: true,
  template: `
    @if (items().length) {
    <section id="blog" class="bg-neutral-50 py-24 dark:bg-neutral-900">
      <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div class="text-center">
          @if (eyebrow()) { <p class="text-sm font-semibold uppercase tracking-widest" style="color:var(--site-accent)">{{ eyebrow() }}</p> }
          <h2 class="mt-3 font-[family-name:var(--site-head-font)] text-3xl font-bold tracking-tight text-neutral-900 dark:text-white sm:text-4xl">{{ title() }}</h2>
          @if (subtitle()) { <p class="mx-auto mt-4 max-w-2xl text-lg text-neutral-600 dark:text-neutral-400">{{ subtitle() }}</p> }
        </div>
        <!-- Yazı yoksa ızgara HİÇ basılmıyor. Örnek metin gösterilseydi
             ziyaretçi uydurma yazı başlıkları görürdü. -->
        <div class="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          @for (b of items(); track b.title) {
            <a [href]="b.url || '#'" class="group flex flex-col overflow-hidden rounded-2xl border border-neutral-200 bg-white transition hover:shadow-lg dark:border-neutral-800 dark:bg-neutral-950">
              <div class="aspect-video overflow-hidden bg-neutral-100 dark:bg-neutral-800">
                @if (b.image) { <img [src]="b.image" [alt]="b.title" class="h-full w-full object-cover transition group-hover:scale-105" /> }
              </div>
              <div class="flex flex-1 flex-col p-5">
                @if (b.date) { <span class="text-xs font-medium uppercase tracking-wide text-neutral-400">{{ b.date }}</span> }
                <h3 class="mt-1 text-lg font-bold text-neutral-900 dark:text-white">{{ b.title }}</h3>
                @if (b.excerpt) { <p class="mt-2 line-clamp-3 text-sm leading-relaxed text-neutral-600 dark:text-neutral-400">{{ b.excerpt }}</p> }
                <span class="mt-4 inline-flex items-center gap-1 text-sm font-semibold" style="color:var(--site-primary)">{{ text.t('readMore') }}</span>
              </div>
            </a>
          }
        </div>
      </div>
    </section>
    }
  `,
})
export class BlogPreviewSection implements OnInit {
  /** Ziyaretçiye görünen kabuk metinleri — dil sitenin ayarından. */
  protected text = inject(SiteChromeText);
  private svc = inject(TenantWebService);

  config = input<SiteConfig>({});
  clientId = input<number>(0);

  /** Sunucudan gelen YAYIMLANMIŞ yazılar. */
  private canli = signal<BlogKart[]>([]);

  ngOnInit() { this.load(); }

  private load(): void {
    const id = this.clientId();
    if (!id) return;

    const qty = Number(cfg(this.config(), 'count', 3)) || 3;
    this.svc.getBlogPosts(id, qty).subscribe({
      next: (l) => this.canli.set(l.map((p) => ({
        image: p.coverImageUrl ?? undefined,
        title: p.title,
        excerpt: p.summary ?? undefined,
        date: p.publishedAt ? new Date(p.publishedAt).toLocaleDateString() : undefined,
        url: '/blog/' + p.slug,
      }))),
      // Uç ulaşılamazsa bölüm sessizce boş kalır — ziyaretçiye hata
      // göstermek yerine bölümü hiç basmamak doğru.
      error: () => this.canli.set([]),
    });
  }
  protected eyebrow = computed(() => cfg(this.config(), 'eyebrow', 'Blog'));
  protected title = computed(() => cfg(this.config(), 'title', this.text.t('fb.sonYazilar')));
  protected subtitle = computed(() => cfg(this.config(), 'subtitle', ''));
  /**
   * Önce ayarda ELLE yazılmış liste (editörde özel içerik girmiş kiracı),
   * yoksa sunucudan gelen gerçek yazılar.
   *
   * ÖRNEK METİN YOK: eskiden ikisi de boşken "Yazı Başlığı 1 / Kısa özet
   * metni buraya gelir" basılıyordu ve bu CANLI sitede uydurma içerik
   * demekti — ziyaretçi var olmayan yazılara tıklıyordu.
   */
  protected items = computed<BlogKart[]>(() => {
    const raw = this.config()['items'];
    if (Array.isArray(raw) && raw.length) return raw.filter((i: BlogKart) => i?.title);
    return this.canli();
  });
}
